import React from 'react';
import { Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { MembershipProduct } from '@/types/membership';

interface MembershipProductsProps {
  products: MembershipProduct[];
  purchasing: string | null;
  onPurchase: (product: MembershipProduct) => void;
}

export default function MembershipProducts({ products, purchasing, onPurchase }: MembershipProductsProps) {
  return (
    <div className="user-product-grid">
      {products.map((product: MembershipProduct) => (
        <div key={product.id} className="user-product-card">
          <div className="text-center mb-4">
            <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
            <div className="user-product-price">
              ¥{product.price}
            </div>
            <p className="text-gray-300">{product.description}</p>
          </div>

          <div className="space-y-2 mb-6">
            {product.features.map((feature: string, index: number) => (
              <div key={index} className="flex items-center text-gray-300">
                <svg className="w-5 h-5 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                {feature}
              </div>
            ))}
          </div>

          <Button
            type="primary"
            size="large"
            block
            onClick={() => onPurchase(product)}
            loading={purchasing === product.id}
            className="user-product-button"
          >
            {purchasing === product.id ? (
              <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            ) : (
              '立即购买'
            )}
          </Button>
        </div>
      ))}
    </div>
  );
}
